export default "__VITE_ASSET__o3I3XSyZ__"